import { Box, Text } from "@chakra-ui/react";
import { NewPageLink } from "../Common/NewPageLink";
import Font, { FontDecoration, Spacing } from "../Utils/Calligraphy";
import { Urls, UrlsLicenses } from "../Utils/Strings";

const SectionSoundsUrlsBox = () => {
  return (
    <>
      <Box flexDirection="row" display="flex">
        <Text
          fontFamily={Font.Medium}
          textAlign={Spacing.TextAlignCenter}
        >{`Sounds from:`}</Text>
        <Box w="4px"></Box>
        <Text
          fontFamily={Font.MediumItalic}
          decoration={FontDecoration.Underline}
          textAlign={Spacing.TextAlignCenter}
        >
          <NewPageLink href={Urls.Freesounds} text="freesound.org" />
        </Text>
      </Box>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink href={Urls.RetroPickup1Sound} text={"Retro pickup 1"} /> by{" "}
        <NewPageLink href={Urls.FreesoundsMaoDin204} text={"MaoDin204"} /> |
        License:{" "}
        <NewPageLink
          href={UrlsLicenses.CC010DEED}
          text={"Creative Commons 0"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={Urls.RetroCoinCollect1Sound}
          text={"Retro coin collect 1"}
        />{" "}
        by <NewPageLink href={Urls.FreesoundsMaoDin204} text={"MaoDin204"} /> |
        License:{" "}
        <NewPageLink
          href={UrlsLicenses.CC010DEED}
          text={"Creative Commons 0"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={Urls.RetroCoinCollect2Sound}
          text={"Retro coin collect 2"}
        />{" "}
        by <NewPageLink href={Urls.FreesoundsMaoDin204} text={"MaoDin204"} /> |
        License:{" "}
        <NewPageLink
          href={UrlsLicenses.CC010DEED}
          text={"Creative Commons 0"}
        />
      </Text>
      <Text
        fontFamily={Font.MediumItalic}
        decoration={FontDecoration.Underline}
        textAlign={Spacing.TextAlignCenter}
      >
        <NewPageLink
          href={Urls.RetroPowerUp3}
          text={"Retro power-up 3"}
        />{" "}
        by <NewPageLink href={Urls.FreesoundsMaoDin204} text={"MaoDin204"} /> |
        License:{" "}
        <NewPageLink
          href={UrlsLicenses.CC010DEED}
          text={"Creative Commons 0"}
        />
      </Text>
    </>
  );
};

export default SectionSoundsUrlsBox;
